// extracted by mini-css-extract-plugin
export default {"followSocialNetwork":"IconSocialNetwork_followSocialNetwork__8stG8","item":"IconSocialNetwork_item__RRnz8"};